import { Phone, MessageCircle } from "lucide-react";
import { SITE, buildWhatsAppLink } from "@/lib/site-config";

export default function StickyContacts() {
  const waLink = buildWhatsAppLink(
    "Hello, I would like to know more about Gurukul Classes."
  );

  return (
    <div
      aria-hidden={false}
      className="fixed bottom-5 left-4 z-30 flex flex-col gap-3 md:bottom-6 md:left-6"
    >
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp"
        aria-label="Chat on WhatsApp"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-emerald-500 text-white shadow-xl shadow-emerald-500/30 ring-2 ring-white transition-all hover:scale-105 hover:bg-emerald-600 md:h-14 md:w-14"
      >
        <MessageCircle className="h-5 w-5 md:h-6 md:w-6" />
      </a>
      <a
        href={`tel:${SITE.phoneTel}`}
        data-testid="sticky-call"
        aria-label="Call now"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-red-600 text-white shadow-xl shadow-red-600/30 ring-2 ring-white transition-all hover:scale-105 hover:bg-red-700 md:h-14 md:w-14"
      >
        <Phone className="h-5 w-5 md:h-6 md:w-6" />
      </a>
    </div>
  );
}
